import { useEffect, useState } from "react";
import { useMetaMask } from "metamask-react";
import { useSelector, useDispatch } from "react-redux";
import {axiosInstance, closeAllModals} from "../../../../../utils";
import "../../league_landing.css";
import $ from "jquery";

let total_page_results = 25;
let current_race_collection = 4;
let collectionList = [];
let leaderboardList = [];
let current_racer_pagenum = 0;
let current_racer_timeseries = 'all-time';
let current_racer_sort = 'rpm';
let current_prophet_pagenum = 0;
let current_prophet_timeseries = 'all-time';
let current_prophet_sort = 'xp';
let racerSectionHTMLArray = [];
let prophetSectionHTMLArray = [];

export const LeagueLeaderboard = (props) => {
    const dispatch = useDispatch();
    const { racerID, userID, accountAddress } = useSelector((state) => state.account);
    const { admin_racers } = useSelector((state) => state.app);

    // if((racerID.length == 0)||(accountAddress.length == 0)) {
    //     dispatch(updateLocation("staging"));
    // }

    const [entrySet, setEntry] = useState(false);
    const [leaderboard_collection_title, setLeaderboardCollectionTitle] = useState('');
    const [currentWeekThrough, setWeekThrough] = useState('');
    const [leaderboardSectionHTML, setLeaderboardSectionHTML] = useState('');
    const [showMoreRacersHTML, setShowMoreRacersHTML] = useState('');
    const [leagueID, setLeagueID] = useState(props.league_id);
    const [leagueSeasonID, setLeagueSeasonID] = useState(props.league_season_id);
    const [racerTimeSeries, setRacerTimeSeries] = useState('all-time');
    const [prophetTimeSeries, setProphetTimeSeries] = useState('all-time');
    const [totalPicksCount,setTotalPicksCount] = useState(5);
    const [totalRacesCount,setTotalRacesCount] = useState(5);

    const bot_pilots = ['https://media.exiledracers.com/assets/bots/PILOT_AUGMENT_BOT.png',
    'https://media.exiledracers.com/assets/bots/PILOT_MERCENARY_BOT.png',
    'https://media.exiledracers.com/assets/bots/PILOT_SERF_BOT.png'];


    function grabSeasonLeaderboard(timeSort,pagenum) {
        current_racer_pagenum = pagenum;

        var addData = new Object();
        addData.leagueID = encodeURIComponent(leagueID);
        addData.leagueSeasonID = encodeURIComponent(leagueSeasonID);
        addData.userID = encodeURIComponent(userID);

        axiosInstance.post('league/season_leaderboard/',addData).then(result => {
            if(Object.keys(result.data).length > 0) {
                var leaderboard_details = result.data; 
                loadSeasonLeaderboard(leaderboard_details,pagenum);
            }
        }).catch(error => {
            console.log(error);
        });
    }

    function updateRacerLeaderBoardSort(newsort) {
        current_racer_sort = newsort;
        window.$(".racer-row-sort-link").each(function() {
            window.$(this).removeClass("white-green-link-active").addClass("white-green-link");
        });
        window.$("#racer-lb-sort-"+newsort).removeClass("white-green-link").addClass("white-green-link-active");
        grabSeasonLeaderboard(racerTimeSeries,0);
    }

    function showMoreResultsRacers(pagenum) {
        $("#showmoreracersbutton").hide();
        $("#showmoreracersloading").show();
        grabSeasonLeaderboard(current_racer_timeseries,pagenum);
    }

    function openInviteModal() {
        var invitebox = document.getElementById('invite-single-box');
        var invite_instance = window.M.Modal.getInstance(invitebox);
        invite_instance.open();
    }

    function loadSeasonLeaderboard(memberarr,pagenum) {
        var ranking_section_html = [];
        var pilotcnt = 0;
        var current_group_number = 0;
        var current_member_standing = 1;
        for(var z = 0; z < memberarr.length;z++) {
            var racer_user_id = memberarr[z]['user_id'];
            var member_status = memberarr[z]['member_status'];
            var racer_name = memberarr[z]['racer_name'];
            var pilot_photo = memberarr[z]['pilot_image_thumbnail'];

            var group_number = memberarr[z]['group_number'];
            var custom_group_name = memberarr[z]['custom_group_name'];
            var league_division_number = memberarr[z]['league_division_number'];

            var current_group_standing = memberarr[z]['current_group_standing'];
            var current_group_underdog = memberarr[z]['current_group_underdog'];
            var current_group_wins = memberarr[z]['current_group_wins'];
            var current_group_xp = memberarr[z]['current_group_xp'];
            var current_group_rpm = memberarr[z]['current_group_rpm'];

            var new_group_seperator = 0;
            if (current_group_number != group_number) {
                current_group_number = group_number;
                new_group_seperator = 1;
                current_member_standing = 1;
            } else {
                current_member_standing = current_member_standing+1;
            }

            var leaderboard_winner_type = memberarr[z].leaderboard_winner_type;

            /* Calculate Race Time */
            // var total_races = memberarr[z].total_races;
            // var total_wins = memberarr[z].total_wins;
            // var win_pct = Math.round((total_wins / total_races)*100);

            var star_icon = '';
            var rowcolor = 'white-text';
            var rowlinkcolor = 'white-green-link';
            var rowbgcolor = '';
            var invite_icon = '';
            if(racer_user_id == userID) {
                //star_icon = <i className="material-icons exr-red-text">star</i>
                rowcolor = 'exr-light-green-text';
                rowbgcolor = 'exr-red-bg';
                rowlinkcolor = 'exr-light-green-text';
            } 
            
            var pilot_image = <div className="exr-stats-light-grey" data-invitename={racer_name} style={{width:'50px',height:'50px',borderRadius:'5px',marginBottom:'7px'}}></div>;
            if(pilot_photo !== null) {
                pilot_image = <img src={pilot_photo} width="50px" data-invitename={racer_name} style={{borderRadius:"5px",lineHeight:'1'}} />;
            }

            var showbattles = 'Y';
            var invite_name_button = <><div className="left" style={{marginRight:"10px",width:"50px"}}>
                                            {pilot_image}
                                        </div>
                                        <div className="left" style={{marginTop:"12px"}}>
                                        {racer_name}
                                        </div></>

            var leaderboardcolor = '';
            if(leaderboard_winner_type == 'top_racer') {
                leaderboardcolor = ' exr-new-light-grey';
                rowcolor = 'exr-light-green-text';
            } else if(leaderboard_winner_type == 'random_draw') {
                leaderboardcolor = ' exr-new-light-grey';
                rowcolor = 'exr-yellow-text';
            }

            

            if(new_group_seperator == 1) {
                var final_group_name = '';
                if(custom_group_name.length > 0) {
                    final_group_name = '// '+custom_group_name.toUpperCase();
                }
                var section_margin_top = '40px';
                if(group_number == 1) {
                    section_margin_top = '10px';
                }

                var tmp_group_start = <div className="row exr-dark-grey-bg" style={{margin:'0',marginTop:section_margin_top,padding:'7px 7px',paddingBottom:'15px',borderRadius:'5px'}}>
                            <div className="row exr-new-light-grey" style={{padding:'5px', margin:'0px',borderRadius:'5px'}}>
                                <div className="row" style={{fontSize:'16px',marginTop:'10px',marginBottom:'10px'}}>
                                    <div className="col s12 headline-text white-text center-align">
                                        GROUP {group_number} {final_group_name}
                                    </div>
                                </div>
                                <div className="row" style={{marginBottom:'0px',marginTop:'0px',fontSize:'12px'}}>
                                    <div className="col s1 headline-text white-text" style={{paddingLeft:'20px'}}>
                                        #
                                    </div>
                                    <div className="col s5 headline-text white-text">
                                        RACER
                                    </div>
                                    <div className="col s2 headline-text white-green-link-active racer-row-sort-link center-align" title="Sort by Most RPM" 
                                        onClick={()=>updateRacerLeaderBoardSort('rpm')} id="racer-lb-sort-rpm" >
                                        RPM
                                    </div>
                                    <div className="col s2 headline-text white-green-link racer-row-sort-link center-align" title="Sort by Most XP" 
                                        onClick={()=>updateRacerLeaderBoardSort('xp')} id="racer-lb-sort-xp" >
                                        XP
                                    </div>
                                    <div className="col s2 headline-text white-green-link racer-row-sort-link center-align" title="Sort by Most Wins" 
                                        onClick={()=>updateRacerLeaderBoardSort('wins')} id="racer-lb-sort-wins" >
                                        WINS
                                    </div>
                                </div>
                            </div>
                        </div>;
                ranking_section_html.push(tmp_group_start);
            }
            var racer_margin_top = '-10px';
            var racer_padding_bottom = '0px';
            if(current_member_standing == 1) {
                racer_margin_top = '-15px';
            }
            if((z+1) >= memberarr.length) {
                racer_padding_bottom = '20px';
            } else if(memberarr[(z+1)]['group_number'] != current_group_number) {
                racer_padding_bottom = '20px';
            }

            var rowkey = z+1+(pagenum*total_page_results);
            var tmp_html = <div key={rowkey} className={"row exr-dark-grey-bg"} id={'leader_row_'+racer_user_id} 
                                style={{margin:'0',padding:'7px',marginBottom:'0px',paddingBottom:racer_padding_bottom,marginTop:racer_margin_top,borderRadius:'5px'}}>
                            <div className={"row "+rowcolor} style={{marginTop:'5px',marginBottom:'0px',fontSize:'16px',fontWeight:'900',paddingTop:'7px'}}>
                                <div className="col s6" style={{overflow:'hidden'}}>
                                    <div className="left" style={{width:'200%'}}>
                                        <div className="left headline-text center-align" style={{fontSize:"16px",marginRight:"10px",letterSpacing:"-1px",width:"32px",marginTop:"15px"}}>
                                            {current_member_standing}
                                        </div>
                                        {invite_name_button}
                                    </div>
                                </div>
                                <div className="col s2 center-align" title="RPM Awarded" style={{marginTop:"12px"}}>
                                    {current_group_rpm.toLocaleString("en-US")}
                                </div>
                                <div className="col s2 center-align" title="XP Earned" style={{marginTop:"12px"}}>
                                    {current_group_xp.toLocaleString("en-US")}
                                </div>
                                <div className="col s2 center-align" style={{marginTop:"12px"}}>
                                    {current_group_wins}
                                </div>
                            </div>
                        </div>;
            ranking_section_html.push(tmp_html);
        }

        var final_section_html_array = [];
        if(pagenum > 0) {
            final_section_html_array = racerSectionHTMLArray.concat(ranking_section_html);
        } else {
            final_section_html_array = ranking_section_html;
        }
        racerSectionHTMLArray = final_section_html_array;
        setLeaderboardSectionHTML(final_section_html_array);

        var nextpage = pagenum+1;
        var showmorebutton = <></>;
        // if(ranking_section_html.length == total_page_results) {
        //     showmorebutton = <div className="row white-text" style={{fontSize:'14px',marginTop:'30px',marginBottom:'5px'}}>
        //                         <div id="showmoreracersbutton" className="center-align" style={{display:'table',margin:'0 auto'}} title="Show More Racers">
        //                             <span className="round-border-button" style={{fontSize:'16px'}} title="Show More Racers"  onClick={() => showMoreResultsRacers(nextpage) }>
        //                                 SHOW MORE RACERS
        //                             </span>
        //                         </div>
        //                         <div id="showmoreracersloading" className="preloader-wrapper small active" style={{left:'49%',marginTop: '-8px',display:'none'}}>
        //                             <div className="spinner-layer spinner-red-only">
        //                                 <div className="circle-clipper left">
        //                                     <div className="circle"></div>
        //                                 </div>
        //                                 <div className="gap-patch">
        //                                     <div className="circle"></div>
        //                                 </div>
        //                                 <div className="circle-clipper right">
        //                                     <div className="circle"></div>
        //                                 </div>
        //                             </div>
        //                         </div>
        //                     </div>;
        // }
        setShowMoreRacersHTML(showmorebutton);
        
        setTimeout(function(){
            $("#showmoreracersbutton").show();
            $("#showmoreracersloading").hide();
        },500);
        setTimeout(function(){
            $("#showmoreracersbutton").show();
            $("#showmoreracersloading").hide();
        },2000);
    }

    function loadLeagueRacedayCompleted() {
        var weekthrough = 1;
        var racedayarr = props.racedays;
        for(var z = 0; z < racedayarr.length;z++) {
            var raceday_number = racedayarr[z]['raceday_number'];
            var date_entry_close = racedayarr[z]['date_race_entry_close'];
            var date_predictions_start = racedayarr[z]['date_race_prediction_start'];
            var date_predictions_close = racedayarr[z]['date_race_prediction_close'];
            var date_simulation_close = racedayarr[z]['date_race_simulation_start'];
            var date_viewing_open = racedayarr[z]['date_race_viewable'];
            var completed_flag = racedayarr[z]['race_completed'];
            var race_next_flag = racedayarr[z]['race_next'];
            var race_ondeck_flag = racedayarr[z]['race_ondeck'];
            var race_track_id = racedayarr[z]['race_track_id'];
            var race_track_galaxy = racedayarr[z]['race_track_galaxy'];
            var race_scoring = racedayarr[z]['race_scoring'];
            var race_laps = racedayarr[z]['race_laps'];
            var race_rpm = racedayarr[z]['race_rpm'];
            var raceday_races = racedayarr[z]['raceday_races'];

            if(completed_flag == 1) {
                weekthrough = z+1;
            } else {
                z = racedayarr.length;
            }
        }

        setWeekThrough(weekthrough);
    }


    window.$(document).ready(function(){
        var sel_elems = document.querySelectorAll('select');
        var instances = window.M.FormSelect.init(sel_elems);
    });

    if(entrySet == false) {
        setEntry(true);
        grabSeasonLeaderboard(current_racer_timeseries,0);
        loadLeagueRacedayCompleted();
    }

    return(<div style={{position:'relative',width:'auto',height:'auto'}}>
        <div className="row white-text " style={{padding:'5px',margin:'0px'}}>
            <div className="col s12 exr-new-dark-grey" style={{borderRadius:'10px',margin:'0px',padding:'0px'}}>
                <div className="row" style={{margin:'0px',marginBottom:'10px',padding:'20px',borderRadius:'10px',minHeight:'70vh'}}>
                    <div className="row" style={{margin:'0px',marginBottom:'0px'}}>
                        <div className="col s6 m6 headline-text white-text left-align" style={{marginTop:'0px',fontSize:'20px'}}>
                            LEADERBOARD
                        </div>
                        <div className="col s6 m6 white-text right-align exr-yellow-text" style={{fontSize:'14px',marginTop:'4px'}}>
                            THROUGH WEEK {currentWeekThrough}
                        </div>
                    </div>
                    
                    {leaderboardSectionHTML}
                </div>
            </div>
        </div>
        <div id="training_box_leaderboard" className="modal page-modal page-modal-large">
            <div className="modal-content">
                <div className="row" style={{marginBottom:'5px',position:'relative'}}>
                    <div className="round-close-button" style={{right:'-10px'}} title="Close" onClick={()=>closeAllModals()}>
                        X
                    </div>
                    <div className="col s12" style={{fontSize:"24px",marginTop:"0px",padding:"0px"}}>
                        <div className="left headline-text" style={{marginLeft:'5px'}}>
                        LEADERBOARDS
                        </div>
                    </div>
                    <div className="col s12" style={{padding:"0px 5px"}}>
                        <div className="divider-thin"></div>
                    </div>
                    <div className="col s12 subheadline-text" style={{marginTop:'20px',fontSize:'16px'}}>
                            Welcome to the EXR Leaderboards! Here you can find the top Racers by RPM and XP as well as the top Prophets correctly predicting races. 
                            <br/><br/><a className="exr-light-green-text">Training Rewards: </a> 
                            Your RPM and XP are your tickets to win rewards in training. 
                            The more RPM and XP you collect by the end of training the higher likelihood you have to win our training rewards game.
                            <br/><br/><a className="exr-light-green-text">Starblazer Badge: </a> 
                            The racers with the most RPM collected at the close of the EXR Training phase will earn the badge of Starblazer and have access to exclusive prizes. 
                            <br/><br/><a className="exr-light-green-text">Leaderboard Tiers: </a> 
                            Where you finish on the leaderboard may or may not determine which <a style={{color:'silver'}}>[REDACTED]</a> you are placed in once the EXR Training Phase is over and <a style={{color:'silver'}}>[REDACTED]</a> starts. 
                            <br/><br/><a className="exr-light-green-text">Prophet Rewards: </a> 
                            The Prophet status is one to be admired. Collect XP for correctly predicting races which give you a higher chance to get Prophet rewards. Top Prophets will earn badges for bragging rights.
                            <br/><br/>
                        </div>
                </div>
            </div>
        </div>
    </div>);
};